import { ReactNode } from "react";
import { cn } from "@/app/utils/cn";

interface DetailItemProps {
  label: string;
  content: ReactNode;
  type?: "default" | "row";
  labelClassName?: string;
  contentClassName?: string;
}

export const DetailItem = ({
  label,
  content,
  type = "default",
  labelClassName,
  contentClassName,
}: DetailItemProps) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2",
        type === "row" &&
          "-m-1 flex-col items-start rounded-lg border border-primary/50 bg-primary/5 p-2",
      )}
    >
      <p
        className={cn(
          "whitespace-nowrap text-sm font-semibold text-black04",
          labelClassName,
        )}
      >
        {label}
      </p>

      {type === "default" && (
        <div className="h-1 w-full border-b-[1px] border-dotted border-[#CACACA]" />
      )}

      <div
        className={cn(
          "max-w-96 whitespace-nowrap text-xs font-semibold",
          contentClassName,
        )}
      >
        {content}
      </div>
    </div>
  );
};
